/* Cart reconciliation uses actual catalogue variants. No discount or price override. */
(function(root,factory){
  const api=factory(typeof module==='object'&&module.exports?require('./core.js'):root.GosQuantityOffers);
  if(typeof module==='object'&&module.exports)module.exports=api;else root.GosQuantityCart=api;
})(typeof globalThis==='object'?globalThis:this,function(core){
  'use strict';
  const fail=(code,message)=>{const e=new Error(message);e.code=code;throw e;};
  const LIMIT=Object.freeze({
    maximum:15000,
    title:'150 € maximum par commande',
    message:'En raison de la forte demande, les commandes sont limitées à 150 € d’articles. Pour un achat plus important, merci de passer plusieurs commandes. Cette mesure vise à limiter les achats automatisés destinés à la revente. Merci de votre compréhension !'
  });
  let cartBusy=false;
  const limitError=amount=>Object.assign(new Error(LIMIT.message),{code:'CART_LIMIT_EXCEEDED',limit:LIMIT.maximum,subtotal:amount});
  const cartSubtotal=cart=>cart.items.reduce((total,item)=>{
    if(!Number.isSafeInteger(item.final_price)||item.final_price<0||!Number.isSafeInteger(item.quantity)||item.quantity<0)fail('INVALID_CART','Le montant du panier ne peut pas être vérifié.');
    return total+item.final_price*item.quantity;
  },0);
  function assertCartLimit(cart){
    const amount=cartSubtotal(cart);if(amount>LIMIT.maximum)throw limitError(amount);return amount;
  }
  const stable=value=>JSON.stringify(Object.entries(value||{}).sort(([a],[b])=>a.localeCompare(b)));
  const props=line=>Object.fromEntries(Object.entries(line.properties||{}).filter(([,v])=>v!==null&&v!==''));
  const identity=line=>`${line.variant_id||line.id}|${stable(props(line))}|${line.selling_plan_allocation?.selling_plan?.id||''}`;
  const signature=cart=>JSON.stringify({currency:cart.currency,items:cart.items.map(x=>[x.key,identity(x),x.quantity,x.final_price]).sort((a,b)=>String(a[0]).localeCompare(String(b[0])))});
  function registry(config){
    core.quote(config,[]);
    const result=new Map();
    for(const group of config.groups)for(const variant of group.variants){
      result.set(String(variant.id),{group,variant});
      for(const ref of Object.values(variant.references||{}))if(ref){
        const old=result.get(String(ref.variantId));
        if(old&&String(old.variant.id)!==String(variant.id))fail('REFERENCE_REUSED','Référence tarifaire ambiguë.');
        result.set(String(ref.variantId),{group,variant});
      }
    }
    return result;
  }
  function plan(config,cart,{additions=[],quantities={},note}={},{catalogueOnly=false}={}){
    if(cart.currency!==config.currency||!Array.isArray(cart.items))fail('INVALID_CART','Devise ou panier incompatible.');
    if(cart.total_discount>0)fail('GOS_DISCOUNT_UNSUPPORTED','Retirez la réduction du panier avant d’utiliser cette offre.');
    const refs=registry(config),original=cart.items.filter(x=>refs.has(String(x.variant_id)));
    const unknownKeys=Object.keys(quantities).filter(key=>!cart.items.some(x=>x.key===key));
    if(unknownKeys.length)fail('STALE_CART','Le panier a changé. Actualisez la page.');
    const intended=[];
    for(const item of cart.items){
      const count=Object.hasOwn(quantities,item.key)?quantities[item.key]:item.quantity;
      if(!Number.isSafeInteger(count)||count<0||count>100)fail('INVALID_QUANTITY','Quantité invalide.');
      const entry=refs.get(String(item.variant_id));
      if(!entry)continue;
      if(count===0)continue;
      if(item.selling_plan_allocation||item.properties?._gos_gift_group)fail('INCOMPATIBLE_OFFER','Retirez l’ancien lot ou abonnement pour utiliser cette offre.');
      intended.push({source:String(entry.variant.id),quantity:count,properties:props(item)});
    }
    for(const item of additions){
      if(!refs.has(String(item.variantId))||String(refs.get(String(item.variantId)).variant.id)!==String(item.variantId))fail('UNKNOWN_VARIANT','Choisissez une variante du produit.');
      intended.push({source:String(item.variantId),quantity:item.quantity,properties:props(item)});
    }
    // Contents describe one paid lot. Order quantity still counts lots, never bottles.
    // Derive the label from the catalogue, including when an old cart is reopened.
    for(const item of intended){
      const {group,variant}=refs.get(item.source);
      if(group.unitsPerItem){
        item.properties['Contenu du lot']=`${group.unitsPerItem} ${group.unitLabel}${group.unitVolume?' de '+group.unitVolume:''}${group.hasFlavour===false?'':' — '+variant.title}`;
      }
    }
    // Pack membership is checked against the complete recipe, never trusted from a price property.
    const instances=new Map(),packQuotes=[];
    const stripPack=item=>{item.properties=Object.fromEntries(Object.entries(item.properties).filter(([k])=>!k.startsWith('_gos_pack')&&k!=='Pack'));};
    for(const item of intended){
      const instance=item.properties._gos_pack_instance;
      if(typeof instance==='string'&&/^[a-zA-Z0-9-]{8,80}$/.test(instance)){
        if(!instances.has(instance))instances.set(instance,[]);instances.get(instance).push(item);
      }else if(Object.keys(item.properties).some(k=>k.startsWith('_gos_pack')))stripPack(item);
    }
    for(const items of instances.values()){
      const choice=String(items[0].properties._gos_pack_choice||''),pack=config.packOffers?.[choice];
      const counts=new Map();for(const item of items)counts.set(item.source,(counts.get(item.source)||0)+item.quantity);
      const ratios=pack?.components.map(c=>(counts.get(String(c.sourceVariantId))||0)/c.quantity)||[];
      const complete=pack&&items.every(i=>String(i.properties._gos_pack_choice)===choice)&&counts.size===pack.components.length&&ratios.length&&Number.isSafeInteger(ratios[0])&&ratios[0]>0&&ratios.every(n=>n===ratios[0]);
      if(!complete){items.forEach(stripPack);continue;}
      const q=core.quotePack(config,choice,ratios[0]);
      if(!catalogueOnly&&!q.checkoutReady)fail('GOS_PACK_UNVERIFIED','Les conditions de ce pack doivent être vérifiées côté GOS.');
      packQuotes.push(q);
      for(const item of items){item.packLine=q.lines.find(l=>l.sourceVariantId===item.source);item.properties.Pack=pack.title;}
    }
    const canonical=intended.filter(x=>!x.packLine).map(x=>({variantId:x.source,quantity:x.quantity}));
    const quote=canonical.length?(catalogueOnly?core.quote(config,canonical):core.prepareHandoff(config,canonical)):{currency:config.currency,subtotal:0,regularSubtotal:0,savings:0,totalQuantity:0,lines:[],checkoutReady:packQuotes.length>0};
    for(const q of packQuotes){
      quote.subtotal+=q.subtotal;quote.regularSubtotal=(quote.regularSubtotal||0)+q.regularSubtotal;
      quote.savings=(quote.savings||0)+q.savings;quote.totalQuantity=(quote.totalQuantity||0)+q.totalQuantity;
      quote.lines.push(...q.lines);quote.checkoutReady=quote.checkoutReady&&q.checkoutReady;
    }
    if(intended.reduce((n,i)=>n+i.quantity,0)>100)fail('INVALID_QUANTITY','Le panier dépasse 100 articles.');
    if(quote.lines.some(line=>!line.checkoutVariantId))fail('GOS_REFERENCE_UNVERIFIED','Une référence tarifaire manque.');
    const targetBySource=new Map(quote.lines.filter(x=>!x.packChoiceId).map(x=>[x.sourceVariantId,x]));
    const desired=new Map();
    for(const item of intended){
      const q=item.packLine||targetBySource.get(item.source),line={id:Number(q.checkoutVariantId),variant_id:Number(q.checkoutVariantId),quantity:item.quantity,properties:item.properties,unitPrice:q.unitPrice};
      const key=identity(line);const old=desired.get(key);
      if(old)old.quantity+=line.quantity;else desired.set(key,line);
    }
    const updates={},adds=[],remaining=new Map([...desired].map(([key,line])=>[key,{...line}]));
    for(const item of original){
      const want=remaining.get(identity(item));
      const count=want?Math.min(item.quantity,want.quantity):0;
      if(count!==item.quantity)updates[item.key]=count;
      if(want)want.quantity-=count;
    }
    for(const line of remaining.values())if(line.quantity>0)adds.push({id:line.id,quantity:line.quantity,properties:line.properties});
    for(const item of cart.items)if(!refs.has(String(item.variant_id))&&Object.hasOwn(quantities,item.key)&&quantities[item.key]!==item.quantity)updates[item.key]=quantities[item.key];
    const foreign=cart.items.filter(x=>!refs.has(String(x.variant_id))).map(x=>({...x,quantity:Object.hasOwn(quantities,x.key)?quantities[x.key]:x.quantity})).filter(x=>x.quantity>0);
    if(note!==undefined&&typeof note!=='string')fail('INVALID_CART','Note invalide.');
    // Enforce the final, repriced basket before any write, including non-offer lines.
    const subtotal=quote.subtotal+cartSubtotal({items:foreign}),beforeSubtotal=cartSubtotal(cart),overLimit=subtotal>LIMIT.maximum;
    // Old/directly-created oversized baskets must remain removable, one line at a time.
    // This exception never authorizes checkout; the storefront checks the final basket again.
    const reducingOversized=beforeSubtotal>LIMIT.maximum&&additions.length===0&&
      cart.items.every(i=>!Object.hasOwn(quantities,i.key)||quantities[i.key]<=i.quantity)&&
      cart.items.some(i=>Object.hasOwn(quantities,i.key)&&quantities[i.key]<i.quantity);
    if(overLimit&&!reducingOversized)throw Object.assign(limitError(subtotal),{currentSubtotal:beforeSubtotal});
    return {quote,subtotal,overLimit,desired:[...desired.values()],foreign,adds,updates,note,before:signature(cart),changed:adds.length>0||Object.keys(updates).length>0||note!==undefined&&note!==(cart.note||'')};
  }
  function verify(config,cart,expected){
    const refs=registry(config),actual=new Map();
    for(const item of cart.items){
      const key=identity(item),old=actual.get(key);
      if(old){old.quantity+=item.quantity;old.prices.add(item.final_price);}else actual.set(key,{quantity:item.quantity,prices:new Set([item.final_price])});
    }
    const desired=new Map();
    for(const line of [...expected.desired,...expected.foreign]){
      const key=identity(line),old=desired.get(key),price=refs.has(String(line.variant_id))?line.unitPrice:line.final_price;
      if(old)old.quantity+=line.quantity;else desired.set(key,{quantity:line.quantity,price});
    }
    if(cart.currency!==config.currency||actual.size!==desired.size)fail('CART_MISMATCH','Le panier a changé. Vérifiez son contenu avant de continuer.');
    for(const [key,line]of desired){const match=actual.get(key);if(!match||match.quantity!==line.quantity||match.prices.size!==1||!match.prices.has(line.price))fail('CART_MISMATCH','Le prix ou le contenu du panier ne correspond pas à l’offre.');}
    if(!expected.overLimit)assertCartLimit(cart);
    return true;
  }
  function createClient(config,request=fetch,root='/',{catalogueOnly=false}={}){
    if(!/^\/[a-zA-Z0-9\/-]*$/.test(root)||root.startsWith('//'))throw Error('Invalid cart root');
    root=root.endsWith('/')?root:root+'/';let busy=false;
    const json=async(path,body)=>{
      const response=await request(`${root}${path}`,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:AbortSignal.timeout(15000)});
      if(!response.ok)fail('CART_REQUEST_FAILED','Le panier n’a pas pu être mis à jour. Rechargez-le pour vérifier son contenu.');return response.json();
    };
    async function reconcile(change={}){
      if(busy||cartBusy)fail('CART_BUSY','Une mise à jour est déjà en cours.');busy=true;cartBusy=true;
      let writeAttempted=false;
      try{
        const before=await json('cart.js'),expected=plan(config,before,change,{catalogueOnly});
        if(expected.desired.length){
          const loaded=new Map();
          const catalogue=async handle=>{if(!loaded.has(handle))loaded.set(handle,await json(`products/${handle}.js`));return loaded.get(handle);};
          for(const group of config.groups.filter(g=>expected.quote.lines.some(l=>l.groupId===g.id))){
            const source=await catalogue(group.handle);
            const needsTariffs=expected.quote.lines.some(l=>l.groupId===group.id&&l.checkoutVariantId!==l.sourceVariantId);
            const tariffs=needsTariffs?await catalogue(group.referenceHandle):{variants:[]};
            for(const line of expected.quote.lines.filter(l=>l.groupId===group.id)){
              const variant=source.variants.find(v=>String(v.id)===line.sourceVariantId);
              const reference=[...source.variants,...tariffs.variants].find(v=>String(v.id)===line.checkoutVariantId);
              if(!variant?.available||!reference?.available)fail('UNAVAILABLE','Un article de votre lot est indisponible.');
              if(reference.price!==line.unitPrice)fail('REFERENCE_PRICE_MISMATCH','Le tarif a changé. Rechargez la page avant de commander.');
            }
          }
        }
        if(expected.changed){
          if(signature(await json('cart.js'))!==expected.before)fail('STALE_CART','Votre panier a changé dans un autre onglet. Rechargez-le.');
          // No automatic retries: a lost response may already have added the items.
          if(expected.adds.length){writeAttempted=true;await json('cart/add.js',{items:expected.adds});}
          if(Object.keys(expected.updates).length||expected.note!==undefined){writeAttempted=true;await json('cart/update.js',{updates:expected.updates,...(expected.note!==undefined?{note:expected.note}:{})});}
        }
        const after=await json('cart.js');verify(config,after,expected);return{cart:after,plan:expected};
      }catch(error){if(writeAttempted)error.needsReview=true;throw error;}finally{busy=false;cartBusy=false;}
    }
    return Object.freeze({reconcile});
  }
  return Object.freeze({plan,verify,createClient,signature,registry,LIMIT,assertCartLimit});
});
